export default "__VITE_ASSET__DB8CulLf__"